<div class="dialog-container">
    <div class="dialog-header">
        <div class="dialog-header-title">
            {{ isEdit ? 'Editar recibo' : 'Emitir recibo' }}
        </div>
    </div>

    <div class="dialog-content">
        <div class="dialog-content-description" *ngIf="data?.item || data?.receipt?.billingItem">
            {{ data?.item?.description || data?.receipt?.billingItem?.description }}
        </div>

        <form [formGroup]="form" class="dialog-form-content">
            <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="12px" class="form-group">
                <mat-form-field appearance="outline" fxFlex>
                    <mat-label>Data de emissão</mat-label>
                    <input matInput [matDatepicker]="issuePicker" formControlName="issueDate" readonly (click)="issuePicker.open()" />
                    <mat-datepicker-toggle matSuffix [for]="issuePicker"></mat-datepicker-toggle>
                    <mat-datepicker #issuePicker></mat-datepicker>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex>
                    <mat-label>Valor</mat-label>
                    <input matInput type="number" min="0.01" step="0.01" formControlName="amount" />
                </mat-form-field>
            </div>

            <div class="amount-warning" *ngIf="hasAmountDivergence">
                O valor informado está diferente do item financeiro pago.
            </div>

            <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="12px" class="form-group">
                <mat-form-field appearance="outline" fxFlex>
                    <mat-label>Referência</mat-label>
                    <input matInput formControlName="paymentReference" />
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex>
                    <mat-label>Forma de pagamento</mat-label>
                    <mat-select formControlName="paymentMethod">
                        <mat-option [value]="null">Não informado</mat-option>
                        <mat-option *ngFor="let method of paymentMethods" [value]="method.value">
                            {{ method.label }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Texto do recibo</mat-label>
                <textarea matInput rows="5" formControlName="description"></textarea>
            </mat-form-field>

            <mat-checkbox formControlName="showSignature">Exibir campo de assinatura</mat-checkbox>
        </form>
    </div>

    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px" class="dialog-actions">
        <button mat-button type="button" mat-dialog-close>Cancelar</button>
        <button mat-raised-button class="btn btn-green" type="button" [disabled]="form?.invalid" (click)="confirm()">
            {{ isEdit ? 'Salvar' : 'Emitir' }}
        </button>
    </div>
</div>
